






















































import { ref, defineComponent, inject } from '@vue/composition-api'
import { importTextbookIssue } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'ImportTextbookIssue',
  components: {
    CloseButton,
  },
  setup(props, context) {
    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function
    const dragover = ref(false)
    const file = ref(null)
    const valid = ref(false)
    const fileRules = [
      (v: unknown) =>
        !!v || context.root.$t('textbookIssue.import.filesRequired'),
    ]

    const addDropFile = (e: DragEvent) => {
      dragover.value = false
      // to support drag and drop https://github.com/vuetifyjs/vuetify/issues/7836#issuecomment-582841222
      file.value =
        e.dataTransfer.files && e.dataTransfer.files.length
          ? e.dataTransfer.files[0]
          : null
    }

    const submit = async () => {
      try {
        loading.value = true
        const newTextbookIssue = await importTextbookIssue(file.value)
        context.emit('import', newTextbookIssue)
        $alert({
          text: context.root.$t('textbookIssue.import.success', {
            textbookName: newTextbookIssue.textbookName,
            textbookIssueName: newTextbookIssue.name,
          }),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      dragover,
      file,
      loading,
      submit,
      addDropFile,
      valid,
      fileRules,
    }
  },
})
